<span *ngIf="isCanAssignTicket">
  <app-role-access [placement]="'bottom-left'" [permission]="'ticket.assign'" [action]="'disable'">
    <button
      data-role-element
      [ngbPopover]="brigadePopContent"
      placement="{{ index ? (index === 0 ? 'bottom-left' : index >= 1 && index <= 4 ? 'bottom' : 'bottom-right') : 'bottom-left' }}"
      triggers="manual"
      autoClose="outside"
      #p2="ngbPopover"
      container="body"
      (click)="toggleWithBrigadeContext(p2)"
    >
      <a class="link link--dotted-blue-dark" *ngIf="!isAssign"> Назначить </a>
      <a class="link link--dotted-gray-dark" *ngIf="isChange && isAssign && !ticket.brigade"> Изменить </a>
    </button>
  </app-role-access>
</span>

<ng-template #brigadePopContent>
  <div class="w-320">
    <div *ngIf="brigadeLoading">
      <app-loader [size]="'small'"></app-loader>
    </div>
    <div *ngIf="!brigadeLoading">
      <div *ngIf="!brigadeError">
        <app-field>
          <content-prefix>
            <div class="field__input-prefix">
              <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </content-prefix>
          <input
            type="text"
            class="input-text input--prefix"
            id="brigadeName"
            placeholder="Поиск по бригадам"
            [(ngModel)]="searchText"
            (input)="searchText = $event.target.value"
          />
        </app-field>
        <div class="search-brigade-block">
          <div class="search-brigade-block__item search-brigade-block__item--placeholder" (click)="onChangeBrigade(ticket, null, 'remove')">Выберите бригаду</div>
          <div class="search-brigade-block__item" *ngFor="let brigade of brigades | searchTextFilter: searchText : 'brigade_name'">
            <div class="grid" (click)="onChangeBrigade(ticket, brigade, 'add')">
              <div class="grid__box" [class.grid__box--size-7]="isGRS" [class.grid__box--size-12]="!isGRS">
                {{ brigade.brigade_name_merged }}
              </div>
              <!-- Для ГРРС показываем человечков -->
              <div class="grid__box grid__box--size-5" *ngIf="isGRS">
                <div class="workers">
                  <span *ngFor="let worker of brigade.workers">
                    <span *ngIf="worker.type === 2" title="{{ Enums.userTypes[2] }}">
                      <app-icon [size]="'18'" [glyph]="'user'" [color]="Enums.userHighlightTypes[2]"></app-icon>
                    </span>
                    <span *ngIf="worker.type === 1" title="{{ Enums.userTypes[1] }}">
                      <app-icon [size]="'18'" [glyph]="'user'" [color]="Enums.userHighlightTypes[1]"></app-icon>
                    </span>
                  </span>
                </div>
              </div>
              <!-- Для обычного диспетчера показываем телефон бригадира -->
              <div class="grid__box grid__box--size-5" *ngIf="!isGRS && brigade.brigade_head && brigade.brigade_head.employee">
                <div class="grid grid--gap-4 ai-center">
                  <div class="grid__box grid__box--size-min">
                    <app-icon [glyph]="'hd-phone-2'" [size]="'14'" [color]="'gray'"></app-icon>
                  </div>
                  <div class="grid__box grid__box--size-min">
                    <span class="text-italic color-gray-dark">{{ brigade.brigade_head.employee.phone | phoneFormat }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="brigadeError">
        <app-message [type]="'error'">
          <div message-content>{{ brigadeError }}</div>
        </app-message>
      </div>
    </div>
  </div>
</ng-template>
